// Caches how many connected calendars the current user has, so the
// /connected_calendars skeleton can render the right number of placeholder
// cards on first paint instead of a hardcoded guess. Written after every
// successful fetch of the calendars list; read synchronously at component
// setup time. Global (not org-scoped) — connected calendars belong to the
// current user. See composables/useSkeletonCountCache.js and
// docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'connected_calendars_count'
const DEFAULT_COUNT = 2

export function getCachedConnectedCalendarsCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedConnectedCalendarsCount(count) {
  setCachedSkeletonCount(KEY, count)
}
